import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'BVUserGeneratedContentLazy',
        path: () => path.join(__dirname, './BVUserGeneratedContent'),
        resolve: () => require.resolveWeak('./BVUserGeneratedContent'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "BVUserGeneratedContentLazy" */ './BVUserGeneratedContent'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
